import React from 'react';

function ManageLicenseInstruction() {
  return (
    <div className="tv-aiTalk__tab-list-instruction">
      <p>Är det första gången följ stegen nedan, ha kundnumret till hands.</p>
      <ol>
        <li>
          Skapa användare – användare kan vara en specifik dator, surfplatta
          eller mobiltelefon.
        </li>
        <li>
          Generera engångslösenord, vid första inloggningen måste ett nytt
          lösenord skapas.
        </li>
        <li>
          Logga in i verktyget genom att gå till{' '}
          <a
            href="https://ai.tolkformedlingvast.se/"
            target="_blank"
            rel="noreferrer"
          >
            https://ai.tolkformedlingvast.se/
          </a>{' '}
          på enheten som verktyget ska användas på och följ instruktionerna
          på skärmen.
        </li>
        <li>
          Lägg till verktyget på startskärmen alternativt klicka på ”Kanske
          senare” för att komma vidare.
        </li>
        <li>
          Logga in i verktyget under fliken ”Användarnamn” med
          engångslösenordet.
        </li>
      </ol>
      <p>
        För att återställa lösenordet, klicka på ”Återställ lösenord” för
        att skapa ett nytt engångslösenord och logga in på nytt.
      </p>
    </div>
  );
}

export default ManageLicenseInstruction;
